<template>
    <div class="fleet-setup-progress-tracker">
        <span class="progress-step">
            Step {{ currentStep }} of 4
        </span>

        <div class="progress-row">
            <div class="progress-bar">
                <div class="progress-fill" :style="{ width: `${progressPercent}%` }"></div>
            </div>

            <div class="progress-badge-ring"
                 :style="{
                                background: `conic-gradient(
                                    #0a71a5 ${progressPercent}%,
                                    #E5E7EB ${progressPercent}% 100%
                                )`
                             }">
                <div class="progress-badge">
                    {{ progressPercent }}%
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import script from './ProgressTracker';
    export default script;</script>

<style lang="less">
    @import "./ProgressTracker.less";
</style>